import { getRootElement } from '@entities/helpers/get-root-element'
import { getConfig } from '@services/context'
import { Entity } from '@loctypes'

export const isThereGlobalConfig = () => {
  if (!getConfig()) {
    throw new Error(`application didn't find "window.flomniConfig" object.`)
  }
}

export const checkVisitorAttributes = (): void => {
  const visitorAttributes = getConfig('visitorAttributes')

  if (!visitorAttributes) {
    return
  }

  if (typeof visitorAttributes !== 'object') {
    throw new Error(`visitorAttributes has to be a Object<[key: string]: any>`)
  }
}

export const isThereRootSelector = (configurationName: Entity) => {
  if (!getRootElement(configurationName)) {
    throw new Error(`container wasn't found to create a widget. Create "<div id="flomni"></div> when you need"`)
  }
}
